import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['window']

  open(event) {
    this.windowTarget.querySelector('.modal-title').innerHTML = event.currentTarget.dataset.modalTitle
    this.windowTarget.querySelector('.modal-body').innerHTML = event.currentTarget.dataset.modalBody
    $(this.windowTarget).modal()
  }

}
